<template>
  <div class="card purple">
    <div class="content">
      <div class="header">
        {{ $t('SERIALPORT') }}
        <i class="right floated microchip icon"></i>
      </div>
      <div class="meta">
        {{
          $t('SERIALPORT_META', {
            serviceName: (service && service.name) || '',
            messagePattern: trigger.configuration.messagePattern
          })
        }}
      </div>
    </div>

    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>
      <!-- SERIALPORT SERVICE -->
      <div class="field">
        <typeahead
          :max-items="100"
          :current-item="service.name"
          :items="allSerialPortServices"
          :label-text="$tc('SERIALPORT_SERVICE', 1)"
          :placeholder-text="$tc('SERIALPORT_SERVICE', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('SERIALPORT_SERVICE', 2) })"
          :select-handler="setService"
          :remove-handler="clearService"
        >
          <template slot="dropdown" slot-scope="props">
            {{ $t(props.item.name) }}
          </template>
        </typeahead>
      </div>
      <!-- MESSAGE PATTERN -->
      <regex-field
        v-model="trigger.configuration.messagePattern"
        :labelText="$t('SERIALPORT_MESSAGE_MATCH')"
      />
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Service, Typenames } from 'services'
import { map } from 'rxjs/operators'
import { Typeahead, RegexField } from 'ui'
import { ActionTypes } from 'store'

export default {
  name: 'SerialPortServiceTrigger',
  components: {
    Typeahead,
    RegexField
  },

  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            serviceId: '',
            messagePattern: ''
          }
        }
      }
    }
  },

  data() {
    return {
      service: {},
      errorMessage: null
    }
  },

  computed: {
    allServices() {
      return this.$store.state.service.items
    },
    allSerialPortServices() {
      return _.map(_.filter(this.allServices, s => s.serviceType === 'SERIALPORT'), s => {
        return { name: s.name || s.id, key: s.id, id: s.id, value: s.id }
      })
    }
  },

  methods: {
    setService(s) {
      this.trigger.configuration.serviceId = s.id
    },
    clearService() {
      this.trigger.configuration.serviceId = ''
    }
  },

  created() {
    Service.readAllServices()
  },

  mounted() {
    if (!_.isEmpty(this.allServices))
      this.service =
        _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
  },

  watch: {
    allServices() {
      if (_.isEmpty(this.service))
        this.service =
          _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
    }
  }
}
</script>
